<div class="fullscreen-spinner" *ngIf="displayLoading">
  <div class="spinner-ring"></div>
</div>
<router-outlet></router-outlet>
<p-toast position="bottom-right"></p-toast>
